import { useQuery } from '@apollo/client';
import { graphql } from '../gql';

export const GET_CLAIM = graphql(`
  query getClaim($uuid: String) {
    claims(filters: { claimUuid: $uuid }) {
      edges {
        node {
          uuid
          referenceId
          tenant
          description
          inLitigation
          documentLink
          litigationUuid
          retention
          limit
          apeeLimit
          limitPaymentTotal
          retentionPaymentTotal
          remainingRetention
          remainingLimit
          isPeerReviewed
          isReferred
          claimants {
            uuid
            firstName
            lastName
            type
            companyName
            contacts {
              type
              value
              uuid
            }
          }
          user {
            uuid
            username
            firstName
            lastName
          }
          status
          insuredEntity {
            node {
              uuid
              referenceId
              type
              submissionType
              agency
              createdAt
              updatedAt
              status
              domains(filters: { source: PRIMARY }) {
                edges {
                  node {
                    domain
                    primary
                    sources
                  }
                }
              }
              industrySectors {
                edges {
                  cursor
                  node {
                    uuid
                    name
                    naicsCode
                    sources
                    primary
                  }
                }
              }
              fundamentals {
                edges {
                  cursor
                  node {
                    uuid
                    revenue
                    projectedRevenue
                    foreignRevenue
                    projectedForeignRevenue
                    employees
                    currentRatio
                    quickRatio
                    cashRatio
                    sources
                    score
                    createdAt
                    updatedAt
                    primary
                    yearEstablished
                  }
                }
              }
              persons {
                edges {
                  cursor
                  node {
                    uuid
                    firstName
                    lastName
                    agent
                    title
                    type
                    source
                    personType {
                      uuid
                      type
                      title
                    }
                    primary
                    contacts {
                      edges {
                        cursor
                        node {
                          uuid
                          type
                          value
                          source
                          primary
                        }
                      }
                    }
                  }
                }
              }
              addresses {
                edges {
                  cursor
                  node {
                    uuid
                    street1
                    street2
                    city
                    regions {
                      edges {
                        cursor
                        node {
                          uuid
                          name
                          iso2Code
                        }
                      }
                    }
                    type
                    postalCode
                    countries {
                      edges {
                        cursor
                        node {
                          uuid
                          name
                          iso2Code
                        }
                      }
                    }
                    source
                    primary
                  }
                }
              }

              aliases {
                edges {
                  node {
                    uuid
                    name
                    type
                    sources
                    createdAt
                    updatedAt
                    primary
                  }
                }
              }
            }
          }
          vendors {
            uuid
            referenceId
            aliases {
              edges {
                node {
                  uuid
                  name
                }
              }
            }
            services {
              edges {
                node {
                  uuid
                  name
                }
              }
            }
          }
          quote {
            node {
              uuid
              referenceId
              limit
              retention
              policies {
                edges {
                  node {
                    uuid
                    type
                    referenceId
                    startDate
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);
export interface IUseClaimQueryArg {
  claimUuid?: string;
}
export function useClaimQuery({ claimUuid }: IUseClaimQueryArg) {
  const { loading, data, error, refetch } = useQuery(GET_CLAIM, {
    variables: {
      uuid: claimUuid,
    },
  });

  return {
    loading,
    error,
    data,
    refetch,
  };
}
